import { Pipe, PipeTransform } from '@angular/core';

/**
 * 期間の"～"が必要か判断するPipe
 * @export
 * @class DateDurationPipe
 * @implements {PipeTransform}
 */
@Pipe({
  name: 'dateDuration'
})
export class DateDurationPipe implements PipeTransform {

  transform(startdate: string, enddate: string): string {
    if (startdate != null && enddate != null) {
      return startdate + "～" + enddate;
    } else if (startdate == null && enddate != null) {
      return "～" + enddate;
    } else if (startdate != null && enddate == null) {
      return startdate + "～";
    } else {
      return null;
    }
  }

}
